import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AccountState {
  accountId: string | null;
}

const initialState: AccountState = {
  accountId: null,
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccountId: (state, action: PayloadAction<string | null>) => {
      state.accountId = action.payload;
    },
  },
});

export const { setAccountId } = accountSlice.actions;

export default accountSlice.reducer;
